
<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.glicemia')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')})}} </span>

    <table class="w-100">
      <tr v-for="elem in data.results">
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/blood_drop.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.blood_glucose_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ bloodGlucoseData.value }} {{bloodGlucoseData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ bloodGlucoseData.previousValue }} {{ bloodGlucoseData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/blood_drop.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.fasting_short') }}?</h5>
              </div>
            </div>
            <span class="card-title">
              {{ fastingData.value }} {{fastingData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ fastingData.previousValue }} {{ fastingData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td rowspan="2">
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.parameters.glicemia')}) }}</h5>
              </div>
            </div>
            <div>
              <table>
                <tr v-for="elem in elem.referenceValues">
                  <td>
                    {{handleReferenceValuesCriterias(elem)}}
                  </td>
                  <td>
                    {{elem.resultMatchingCriteria}}
                  </td>
                </tr>
              </table>
            </div>

          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="2">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }}</h5>
              </div>
            </div>
            <span :style="{ color: elem.resultColour }">
              {{ elem.resultName }}
            </span>
          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="3">
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              {{ elem.recommendations }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bloodGlucoseData: null,
      fastingData: null,
    }
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if(elem.attributeCode === 'G') {
        this.bloodGlucoseData = elem
      } else if(elem.attributeCode === 'GF') {
        this.fastingData = elem
      }
    })

    //console.log(this.data)
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = ""
      let index = 0
      let criteriasLength = elem.criteriaList.length
      if(elem.operator === "AND") {
        elem.criteriaList.forEach(elem => {
          str+= `${elem.attributeName} ${elem.criteria} `
          ++index
          if (index < criteriasLength) {
            str += "& "
          }

        })
      }
      return str
    }
  }
}
</script>


<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}



table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}


</style>
